// Preview reader route. Same shape as the public reader but fetches the
// proposed (not yet published) glossary by passing `preview=1`.

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { useDoc } from "../data/api";
import { ReadingPage } from "../render/ReadingPage";

export const previewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preview/$docId",
  component: PreviewPage,
});

function PreviewPage() {
  const { docId } = previewRoute.useParams();
  const query = useDoc(docId, { preview: true });

  if (query.isPending) return <div className="maisight-loading">Loading…</div>;
  if (query.isError) {
    return (
      <div className="maisight-error" role="alert">
        Could not load preview: {query.error.message}
      </div>
    );
  }
  const { doc, glossary, config, equations, corpus_glossary } = query.data;
  const equationsArray =
    equations && "equations" in equations ? equations.equations : undefined;
  return (
    <ReadingPage
      doc={doc}
      glossary={glossary}
      config={config}
      equations={equationsArray}
      corpusGlossary={corpus_glossary ?? null}
    />
  );
}
